export const notifyTypeOptions = [
  {label: '自动', value: 1},
  {label: '手动', value: 2},
];

export const notifyTypeEnum = {
  auto: 1,
  manual: 2
};
